module.exports = __webpack_public_path__ + "static/media/reference-slider-29.9c92a39d.jpg";